module.exports = __webpack_public_path__ + "media/images/application/icons/download-78a1928136951917c7676a469bf7e3be.svg";